<template>
  <div class="product-list">
    <el-row :gutter="20" class="operate-bar">
      <el-col :span="8" align="left">
        <!-- 新增套餐组按钮 -->
        <el-button v-if="hasPermission('product:edit')" icon="el-icon-plus" type="primary" @click="openAddDialog"
          v-hasPermission="'product:edit'">新增套餐组</el-button>
        <el-button v-if="hasPermission('product:edit')" icon="el-icon-files" type="success" @click="openGenerateDialog"
          v-hasPermission="'product:edit'">一键生成标准套餐</el-button>
      </el-col>
      <!-- 搜索区域 -->
      <el-col :span="16" align="right">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="组织机构">
              <el-select v-model="searchForm.orgIds" filterable multiple placeholder="请选择组织机构" clearable>
                <el-option v-for="org in userOrgs" :key="org.id" :label="org.orgName" :value="org.id"></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="套餐组名称">
            <el-input v-model="searchForm.name" placeholder="请输入套餐组名称" maxlength="20"></el-input>
          </el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="loadProducts">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table :data="products" border stripe style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="name" label="套餐组名称" header-align="center"></el-table-column>
      <el-table-column prop="orgName" label="组织机构" header-align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center"></el-table-column>
      <el-table-column prop="status" label="启用状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66"
            :active-value="1" :inactive-value="0" :disabled="!hasPermission('product:edit')"
            @change="handleStatusChange(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-tooltip content="编辑" placement="top" v-if="hasPermission('product:edit')">
            <el-button icon="el-icon-edit" type="primary" circle v-hasPermission="'product:edit'"
              @click="openEditDialog(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip content="查看套餐" placement="top">
            <el-button icon="el-icon-coin" type="warning" circle
              @click="$router.push({ name: 'ProductItemList', query: { productId: scope.row.id } })"></el-button>
          </el-tooltip>
          <el-tooltip content="分配设备" placement="top">
            <el-button icon="el-icon-aim" type="success" circle v-hasPermission="'product:edit'"
              @click="openAssignTargetDialog(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total"></el-pagination>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px">
        <el-form-item label="组织机构" prop="orgId">
          <el-select v-model="form.orgId" filterable placeholder="请选择组织机构" clearable style="width: 80%" :disabled="isEdit">
            <el-option v-for="org in userOrgs" :key="org.id" :label="org.orgName" :value="org.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐组名称" prop="name">
          <el-input v-model="form.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark" rows="3" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false; $refs.form.resetFields()">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 一键生成对话框 -->
    <el-dialog :visible.sync="generateVisible" title="一键生成标准套餐" width="400px">
      <el-form :model="generateForm">
        <el-form-item label="组织机构" prop="orgId">
          <el-select v-model="generateForm.orgId" filterable placeholder="请选择组织机构" clearable>
            <el-option v-for="org in userOrgs" :key="org.id" :label="org.orgName" :value="org.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancelGenerate">取消</el-button>
        <el-button type="primary" @click="submitGenerate">确认生成</el-button>
      </div>
    </el-dialog>

    <!-- 分配设备对话框 -->
    <el-dialog title="分配设备" :visible.sync="assignTargetVisible" width="1000px">
      <el-transfer :data="targets" :titles="['可选设备', '已选设备']"
        :props="{ key: 'imei'}" v-model="selectedTargetImeis">
        <span slot-scope="{ option }">{{ option.warZone }} - {{ option.targetNo }} ({{ option.imei }})</span>
      </el-transfer>
      <div slot="footer">
        <el-button @click="assignTargetVisible = false; targets = []">取消</el-button>
        <el-button type="primary" @click="saveTargets">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import productApi from '../../api/product'
import targetApi from '../../api/target'
import { hasPermission } from '../../utils/hasPermission'
import store from '../../store';

export default {
  name: 'ProductList',
  data() {
    return {
      // 表格数据
      products: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,

      // 搜索表单
      searchForm: {
        orgIds: [],
        name: ''
      },

      // 一键生成相关
      generateVisible: false,
      generateForm: {
        orgId: ''
      },

      // 选中的行
      selectedIds: [],

      // 对话框
      dialogVisible: false,
      dialogTitle: '新增套餐组',
      isEdit: false,
      recordId: null, // 编辑时记录当前套餐组的ID，用于排除自身
      form: {
        id: null,
        orgId: '',
        name: '',
        remark: '',
        status: 0
      },
      rules: {
        orgId: [
          { required: true, message: '请选择组织机构', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入套餐组名称', trigger: 'blur' },
          { min: 1, max: 20, message: '套餐组名称长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        remark: [
          { min: 1, max: 200, message: '备注长度在 1 到 200 个字符', trigger: 'blur' }
        ]
      },

      // 分配设备相关
      selectedProductId: null, // 选中的套餐组ID
      targets: [], // 可选设备列表
      assignTargetVisible: false,
      selectedTargetImeis: [],// el-transfer绑定的已选设备IMEI
      hasAssignedTarget: false, // 是否已分配设备

      userOrgs: store.state.user.userInfo.orgs,
    }
  },

  created() {
    this.loadProducts()
  },

  methods: {
    // 加载套餐组列表
    loadProducts() {
      // 组装请求参数
      const params = {
        searchOrgIds: this.searchForm.orgIds, // 搜索-组织机构ID
        name: this.searchForm.name,           // 搜索-套餐组名称
        page: this.currentPage,               // 分页-当前页
        size: this.pageSize,                  // 分页-每页条数
        userOrgIds: this.userOrgs.map(org => org.id) // 用户所负责的组织机构ID列表
      };
      productApi.findAllProduct(params).then(response => {
        if (response.success) {
          this.products = response.data.data
          this.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载套餐组失败：' + error.message)
      })
    },

    // 加载所有未分配设备
    loadTargets() {
      const params = {
        userOrgIds: this.userOrgs.map(org => org.id), // 用户所负责的组织机构ID列表
        productId: this.selectedProductId,
        hasAssignedTarget: this.hasAssignedTarget
      };
      targetApi.findForAssignTarget(params).then(response => {
        if (response.success) {
          this.targets = response.data
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载设备失败：' + error.message)
      })
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        orgIds: [],
        name: ''
      }
      this.loadProducts()
    },

    // 每页条数变化时
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadProducts(); // 重新加载
    },

    // 当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadProducts(); // 重新加载
    },

    // 选择变化
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id)
    },

    // 打开新增对话框
    openAddDialog() {
      if (!hasPermission('product:edit')) {
        this.$message.error('无新增套餐组权限');
        return;
      }
      this.dialogTitle = '新增套餐组'
      this.isEdit = false
      this.recordId = null
      this.form = {
        id: null,
        orgId: '',
        name: '',
        remark: '',
        status: 0
      }
      this.dialogVisible = true
    },

    // 打开生成对话框
    openGenerateDialog() {
      if (!hasPermission('product:edit')) {
        this.$message.error('无一键生成标准套餐权限');
        return;
      }
      this.dialogTitle = '一键生成标准套餐'
      this.isEdit = false
      this.recordId = null
      this.form = {
        id: null,
        orgId: '',
        name: '',
        remark: '',
        status: 0
      }
      this.dialogVisible = true
    },

    // 打开编辑对话框
    openEditDialog(row) {
      if (!hasPermission('product:edit')) {
        this.$message.error('无编辑套餐组权限');
        return;
      }
      this.dialogTitle = '编辑套餐组'
      this.isEdit = true
      this.recordId = row.id
      this.form = { ...row }
      this.dialogVisible = true
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 更新套餐组
            productApi.updateProduct(this.form.id, this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '更新成功')
                this.dialogVisible = false
                this.loadProducts()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('更新失败：' + error.message)
            })
          } else {
            // 新增套餐组
            productApi.addProduct(this.form).then(response => {
              if (response.success) {
                this.$message.success(response.message || '新增成功')
                this.dialogVisible = false
                this.loadProducts()
              } else {
                this.$message.error(response.message)
              }
            }).catch(error => {
              this.$message.error('新增失败：' + error.message)
            })
          }
        }
      })
    },

    // 修改套餐组状态
    handleStatusChange(row) {
      if (!hasPermission('product:edit')) {
        this.$message.error('无操作套餐组权限');
        return;
      }
      this.$confirm(`确定要${row.status === 1 ? '启用' : '禁用'}该套餐组吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        productApi.productStatus(row.id, row.status).then(response => {
          if (response.success) {
            this.$message.success(response.message || '操作成功')
            this.loadProducts()
          } else {
            this.$message.error(response.message)
          }
        }).catch(error => {
          row.status = row.status === 1 ? 0 : 1;
          this.$message.error('操作失败：' + error.message)
        })
      }).catch(() => {
        // 取消操作（此处可留空，仅用于捕获异常）
        row.status = row.status === 1 ? 0 : 1;
      });
    },

    // 一键生成相关方法
    openGenerateDialog() {
      if (!hasPermission('product:edit')) {
        this.$message.error('无一键生成标准套餐权限');
        return;
      }
      this.generateVisible = true;
      this.$nextTick(() => {
        this.generateForm.orgId = ''
      });
    },

    cancelGenerate() {
      this.generateForm.orgId = ''
      this.generateVisible = false; // 关闭对话框
    },

    // 确认一键生成
    submitGenerate() {
      // 检查是否选择了组织
      if (!this.generateForm.orgId) {
        this.$alert('请选择组织', '提示', {
          confirmButtonText: '确定',
          type: 'warning' // 警告类型（可选，控制图标）
        });
        return;
      }
      // 调用API
      productApi.generateProduct(this.generateForm.orgId).then(response => {
        if (response.success) {
          this.generateVisible = false;
          this.cancelGenerate();
          this.loadProducts(); // 刷新套餐组列表
        } else {
          this.$message.error(response.message || '生成失败');
        }
      }).catch(err => {
        this.$message.error(`导入失败：${err.message || '服务器错误'}`);
      });
    },

    // 打开分配设备对话框
    openAssignTargetDialog(row) {
      if (!hasPermission('product:edit')) {
        this.$message.error('无分配设备权限');
        return;
      }
      this.selectedProductId = row.id
      this.assignTargetVisible = true
      // 获取已选设备IMEI
      this.selectedTargetImeis = (row.targets || []).map(target => target.imei)
      this.hasAssignedTarget = (row.targets || []).length > 0
      this.loadTargets();
    },

    // 保存设备分配
    saveTargets() {
      productApi.assignTargets(this.selectedProductId, this.selectedTargetImeis).then(response => {
        if (response.success) {
          this.$message.success(response.message || '设备分配成功')
          this.assignTargetVisible = false
          this.loadProducts()
          this.targets = []
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('设备分配失败：' + error.message)
      })
    },

    hasPermission(permCode) {
      return hasPermission(permCode);
    },
  }
}
</script>

<style scoped>
/* 强制左右列等宽，调整整体布局 */
::v-deep .el-dialog .el-transfer {
  /* 确保组件宽度与设置的width一致，避免留白 */
  width: 100% !important;
}

/* 强制左右列表格宽度相等（各占40%） */
::v-deep .el-dialog .el-transfer-panel {
  width: 40% !important;
  /* 修复右侧留白：去掉默认的margin-right */
  margin-right: 0 !important;
}

/* 穿透作用域，强制 el-transfer 整体左对齐 */
::v-deep .el-dialog .el-transfer {
  text-align: left !important;
  /* 覆盖全局的 center */
}

/* 确保左右面板内的内容也左对齐 */
::v-deep .el-dialog.el-transfer-panel {
  text-align: left !important;
}

/* 修复选项项（复选框+文字）的对齐 */
::v-deep .el-dialog.el-transfer-panel__item {
  display: flex;
  align-items: center;
  /* 复选框与文字垂直居中 */
}
</style>